import { createApiInstance } from '@/infrastructure/apis/apiInstance'

const userProfileApi = {
  recordUserAppStartup: async () => {
    const response = await createApiInstance().post('/UserProfile/record-app-startup')
    return response.data
  },
}
export default userProfileApi
